import { useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import api from '@/services/api'
import { productService } from '@/services/products'
import { useCartStore, CartItem } from '@/stores/cartStore'

/**
 * "Finish my order" link from the abandoned-basket follow-up (Sales Strategy, owner 2026-10-15).
 * Puts the saved basket back on THIS device — they may have started on a laptop and opened the
 * text on their phone — then goes to the basket. Current prices are always used.
 */
export default function BasketRestore() {
  const { token } = useParams()
  const navigate = useNavigate()
  const [msg, setMsg] = useState('Getting your basket…')
  useEffect(() => {
    let cancelled = false
    ;(async () => {
      try {
        const saved = (await api.get(`/sales/basket/${token}`)).data
        const items: CartItem[] = []
        for (const si of saved.items || []) {
          try {
            const product = await productService.getProduct(si.product_id)
            if (product && (product as any).id) items.push({ product, quantity: si.quantity || 1, sim_format: si.sim_format || undefined })
          } catch { /* product no longer sold — skip */ }
        }
        if (cancelled) return
        if (items.length) {
          const store = useCartStore.getState()
          const have = new Set(store.items.map((i) => i.product.id))
          store.replaceItems([...store.items, ...items.filter((i) => !have.has(i.product.id))])
        }
        if (saved.referral_code) useCartStore.getState().setReferralCode(saved.referral_code)
        navigate('/cart', { replace: true })
      } catch {
        if (!cancelled) { setMsg('That link has expired — taking you to the shop…'); setTimeout(() => navigate('/shop', { replace: true }), 1500) }
      }
    })()
    return () => { cancelled = true }
  }, [token, navigate])
  return <div className="max-w-md mx-auto px-4 py-24 text-center text-gray-600">{msg}</div>
}
